"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/WeatherRain.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var WeatherRain = function WeatherRain(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "solid-icon",
    viewBox: "0 0 170.22 150.06"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Raining Icon"), _react2.default.createElement("g", {
    className: "rain-cloud",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "cloud",
    d: "M143.78 35.41c-.75 0-1.48 0-2.22.1A50 50 0 0 0 55 18.35a37.84 37.84 0 1 0-9.22 74.54c6 0 92.93-.59 98-.59 14.61 0 26.45-15.84 26.45-30.45a26.45 26.45 0 0 0-26.45-26.44z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("g", {
    className: "rain",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "drop",
    d: "M123 119.79a3.5 3.5 0 0 1-2.39-6.06l11-10.22a3.5 3.5 0 0 1 4.77 5.12l-11 10.22a3.49 3.49 0 0 1-2.38.94z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "drop-2",
    "data-name": "drop",
    d: "M90.55 150.06a3.5 3.5 0 0 1-2.38-6.06l11-10.22a3.5 3.5 0 1 1 4.77 5.12l-11 10.22a3.48 3.48 0 0 1-2.39.94z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "drop-3",
    d: "M79 119.79a3.5 3.5 0 0 1-2.39-6.06l11-10.22a3.5 3.5 0 0 1 4.77 5.12l-11 10.22a3.48 3.48 0 0 1-2.38.94z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "drop-4",
    d: "M46.53 150.06a3.5 3.5 0 0 1-2.39-6.06l11-10.22a3.5 3.5 0 0 1 4.77 5.12l-11 10.22a3.49 3.49 0 0 1-2.38.94z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "drop-5",
    d: "M36 119.79a3.5 3.5 0 0 1-2.39-6.06l11-10.22a3.5 3.5 0 0 1 4.77 5.12l-11 10.22a3.49 3.49 0 0 1-2.38.94z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "drop-6",
    d: "M3.5 150.06A3.5 3.5 0 0 1 1.11 144l11-10.22a3.5 3.5 0 0 1 4.77 5.12l-11 10.22a3.49 3.49 0 0 1-2.38.94z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33
    },
    __self: undefined
  }))));
};
exports.default = WeatherRain;